import { Link } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import T from '@wojtekmaj/react-t';

import {
  ContentWrapper,
  Image,
  ImagePlaceholder,
  ImageWrapper,
  Name,
  Price,
  Reward,
} from './item.styles';

import useI18nText from '../../../../../../../hooks/useI18nText';

import { formatNumber } from '../../../../../../../utils/helpers';

import { vendorCardSubscriptionState } from '../../../../../../../store';

import lockIcon from '../../../../../../../static/lock.svg';
import rewardIcon from '../../../../../../../static/reward.svg';

import type { Reward as RewardType } from '@rewardopl/types';

type ItemProps = {
  reward: RewardType;
};

export default function Item({ reward }: ItemProps) {
  const cardSubscription = useAtomValue(vendorCardSubscriptionState);

  const { balance } = cardSubscription;
  const { _id: rewardId, name, name_i18n: nameI18n, picture, price } = reward;

  const nameString = useI18nText(nameI18n, name);

  const isAvailable = balance >= price;

  return (
    <Reward as={Link} to={`/rewards/${rewardId}`}>
      <ImageWrapper>
        {picture ? (
          <Image alt={nameString} src={`/api/uploads/${picture}?w=${118 * devicePixelRatio}`} />
        ) : (
          <ImagePlaceholder alt={nameString} src={rewardIcon} />
        )}
      </ImageWrapper>
      <ContentWrapper>
        <Price>
          {isAvailable ? null : <img alt="" src={lockIcon} />}
          {formatNumber(price)} <T>{`point${price === 1 ? '' : 's'}`}</T>
        </Price>
        <Name>{nameString}</Name>
      </ContentWrapper>
    </Reward>
  );
}
